import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ResetPasswordForm from "../../../components/Auth/ResetPasswordForm";
import "../../../assets/scss/auth.scss";
import { fpSetNewPassword } from "../../../services/admin/auth";
import useQuery from "../../../hooks/useQuery";
import { ADMIN_ROUTES, USER_ROUTES } from "../../../constants/appRoutes";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { queryParams } = useQuery();
  const location = useLocation();

  const [stateLoading, setStateLoading] = useState<boolean>(false);

  const handleLoading = (value: boolean) => {
    setStateLoading(value);
  };

  const handleBtnLogin = () => {
    if (location.pathname.includes(ADMIN_ROUTES.ROOT)) {
      navigate(`${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.LOGIN}`);
    } else {
      navigate(USER_ROUTES.ROOT);
    }
  };

  const handleOnSubmit = (values: any) => {
    setStateLoading(true);
    const apiData = {
      token: queryParams?.token,
      password: values?.password,
      email: queryParams?.email,
    };
    fpSetNewPassword(handleLoading, handleBtnLogin, apiData);
  };

  return (
    <div className="login-page flex items-center justify-center">
      <div className="main-div login-main-div bg-white w-[758px] h-fit p-2 m-2">
        <ResetPasswordForm
          btnLoader={stateLoading}
          handleOnSubmit={handleOnSubmit}
        />
        <div className="text-center text-black">
          <p>
            Login your account?{" "}
            <button
              onClick={handleBtnLogin}
              className="underline font-semibold"
            >
              Sign In
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
